export type MatchaFeeType = 'auto' | 'standard' | 'crossChain' | 'limitOrder' | 'solana';

export type MatchaFeeConfig = {
  /** Fee applied to default trades, in basis points. */
  default: number;
  /** Fee applied to stable-to-stable trades, in basis points. For Solana, this covers all like-kind pairs. */
  stables: number;
};

/**
 * Central fee definitions used by Matcha UI and request builders.
 *
 * Standard trade fees are configured in the Zippo Admin Retool dashboard. The
 * values here mirror that configuration and are used only for display.
 *
 * Cross-chain, limit-order, and Solana fees are controlled in this codebase.
 *
 * Gasless fees are configured in the rfq-api service; these values mirror that
 * configuration for display and fallback labeling.
 */
export const matchaFees: Record<MatchaFeeType, MatchaFeeConfig> = {
  auto: { default: 25, stables: 0 },
  standard: { default: 25, stables: 0 },
  crossChain: { default: 40, stables: 4 },
  limitOrder: { default: 25, stables: 2 },
  solana: { default: 25, stables: 0 },
};
